export default {
  functionKey: "NBVAL",
  title: "NBVAL",
  group: "Calcul",
  origin: [],
  target: [],
  targetRequired: true,
  multiOrigin: true,
  description: "Compte le nombre de colonnes non vides pour chaque ligne. Ajoutez les colonnes en Origine.",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol, allOrigins = []) {
    const cols = allOrigins.length > 0 ? allOrigins : (origin ? [origin] : []);
    if (cols.length === 0) return { displayCode: '', safeCode: '' };
    const safeCode = `${destination}=String([${cols.join(',')}].filter(function(v){return v!==''&&v!==null&&v!==undefined;}).length);`;
    return { displayCode: safeCode, safeCode };
  }
}
